<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2022-2024, Vector Software BV                             **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Vector Software BV. Unauthorized copying or disclosure of this file,    **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
*****************************************************************************
-->

<template>
    <v-dialog @click:outside="onClose()" v-model="dialog" id="calendar" width="800px"
        :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <v-card-title class="py-6">
                <div class="text-h6 text-sm-h4" style="word-break: break-word;">
                    {{ language.t("Vector.Planning.planning") }}
                </div>
                <v-spacer></v-spacer>
                <v-btn icon color="blue darken-1" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-calendar ref="calendar" v-model="value" color="primary" type="week" :interval-minutes="120"
                    :interval-count="12" :interval-format="intervalFormat" :events="events" :event-color="getEventColor"
                    :event-ripple="false" @change="getEvents" @mousedown:time="newEvent" @mousedown:event="editEvent">
                    <template v-slot:event="{ event, timed, eventSummary }">
                        <div class="v-event-draggable">
                            <component :is="{ render: eventSummary }"></component>
                        </div>
                    </template>
                </v-calendar>
            </v-card-text>
        </v-card>

        <v-dialog @click:outside="planning = false" v-model="planning" id="newTask" width="500px">
            <v-card>
                <v-card-title class="py-6">
                    <div v-if="!editing" class="text-h6 text-sm-h4" style="word-break: break-word;">
                        {{ language.t("Vector.Planning.newTask") }}
                    </div>
                    <div v-if="editing" class="text-h6 text-sm-h4" style="word-break: break-word;">
                        {{ language.t("Vector.Planning.editTask") }}
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row><v-col>{{ language.t("Vector.Planning.day") }}: </v-col><v-col><v-select v-model="selectDay"
                                    placeholder="Select" :items="weekdays">
                                </v-select></v-col></v-row>
                        <v-row><v-col>{{ language.t("Vector.Planning.startTime") }}: </v-col><v-col><v-time-picker
                                    v-model="time" format="24hr"></v-time-picker></v-col></v-row>
                        <v-row><v-col>{{ language.t("Vector.Planning.task") }}: </v-col><v-col><v-select
                                    v-model="selectTask" placeholder="Select" :items="tasks" item-text="name"
                                    item-value="taskId">
                                </v-select></v-col></v-row>
                        <v-row> <v-spacer></v-spacer> <v-btn v-if="selectTask.taskId != 0" @click="onSelectRoute">{{
                            selectedLine == null ? language.t("Vector.Planning.selectRoute") : language.t("Vector.Planning.selectedRoute") }}</v-btn></v-row>
                        <v-row><v-col><v-alert v-if="error" dense type="warning">{{
                            language.t("Vector.Planning.noTask") }}</v-alert></v-col></v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-on:click="saveEvent">{{
                        language.t("App.save") }}</v-btn>
                    <v-btn color="error" v-if="editing" v-on:click="deleteEvent"> {{
                        language.t("App.remove") }}</v-btn>
                    <v-btn v-on:click="planning = false; resetFields()">{{
                        language.t("App.cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            dialog: false,
            planning: false,
            value: '',
            events: [],
            weekdays: [this.language.t("Vector.Planning.sunday"), this.language.t("Vector.Planning.monday"), this.language.t("Vector.Planning.tuesday"),
            this.language.t("Vector.Planning.wednesday"), this.language.t("Vector.Planning.thursday"),
            this.language.t("Vector.Planning.friday"), this.language.t("Vector.Planning.saturday")],
            tasks: null,
            selectDay: null,
            selectTask: { taskId: 0, name: "taak" },
            time: null,
            error: false,
            editing: false,
            openedPlanningId: 0,
            selectingLine: false,
            selectedLine: null
        };
    },
    computed: {
        account() {
            return this.$selectedVector.accountId;
        }
    },
    mounted: function () {
        this.getTaskNames();
    },
    watch: {
    },
    methods: {
        onClose() {
            this.dialog = false;
        },
        getEventColor(event) {
            const rgb = parseInt(event.color.substring(1), 16)
            const r = (rgb >> 16) & 0xFF
            const g = (rgb >> 8) & 0xFF
            const b = (rgb >> 0) & 0xFF

            return event.color
        },
        getEvents(obj) {
            const events = [];
            const timed = true;

            const currentDate = new Date();

            this.$axios.get(route('api.vector.planning', this.account)).then((res) => {
                res.data.forEach(planning => {
                    const planningTime = new Date(planning.startTime);
                    const difference = (planningTime.getDay() - currentDate.getDay()) * 86400000;
                    var start = new Date(currentDate.getTime() + difference);
                    start.setHours(planningTime.getHours());
                    start.setMinutes(planningTime.getMinutes());
                    start = start.getTime();
                    const end = start + 60 * 60 * 3000;

                    events.push({
                        name: planning.taskname,
                        color: "#2196F3",
                        start,
                        end,
                        timed,
                        moreInformation: planning.planningId + ":" + planning.fk_taskId
                    });
                });
            });

            this.events = events;
        },
        getTaskNames() {
            this.requestCancelToken = this.$axios.CancelToken.source();

            var _this = this;
            var filter = false ? "?onlyNew=true" : "";

            this.$axios
                .get(route("api.tasks") + filter, {
                    cancelToken: this.requestCancelToken.token,
                })
                .then((res) => {
                    var tempTasks = [];
                    for (let i = 0; i < res.data.length; i++) {
                        if ("__TASKSTATUSTYPE_NEW" === res.data[i].status) {
                            tempTasks.push(res.data[i]);
                        }
                    };
                    tempTasks.sort(function (x, y) {
                        return new Date(y.edited) - new Date(x.edited);
                    });
                    _this.tasks = tempTasks;
                })
                .catch((err) => {
                    console.log(err);
                });

        },
        newEvent(tms) {
            this.planning = true;
            let temphour = tms.time.split(':')[0];
            let tempmin = tms.time.split(':')[1];

            if (Number(tempmin) < 15) {
                tempmin = '00';
            }
            else if (Number(tempmin) < 44 && Number(tempmin) > 14) {
                tempmin = '30';
            }
            else {
                tempmin = '00'; temphour = Number(temphour) + 1;
            }
            this.time = temphour + ':' + tempmin;
            this.selectDay = this.weekdays[tms.weekday];
            this.editing = false;
        },
        saveEvent() {
            const today = new Date();
            const difference = ((this.weekdays.indexOf(this.selectDay)) - today.getDay()) * 86400000;
            const selectedTime = new Date("1970-01-01T" + this.time);

            var timestamp = new Date(today.getTime() + difference);
            timestamp.setHours(selectedTime.getHours());
            timestamp.setMinutes(selectedTime.getMinutes());

            var month = '' + (timestamp.getMonth() + 1);
            var day = '' + timestamp.getDate();
            const year = timestamp.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            var hours = '' + timestamp.getHours();
            var minutes = '' + timestamp.getMinutes();
            var seconds = '' + timestamp.getSeconds();

            if (hours.length < 2)
                hours = '0' + hours;
            if (minutes.length < 2)
                minutes = '0' + minutes;
            if (seconds.length < 2)
                seconds = '0' + seconds

            var newDate = [year, month, day].join('-');
            var newTime = [hours, minutes, seconds].join(':');

            if ((typeof this.selectTask !== 'object') && this.selectedLine !== null) {
                if (this.editing) {
                    this.$axios.post(route('api.vector.planning.update', [this.account, this.selectTask, newDate + " " + newTime, this.openedPlanningId]), { 'lineData': this.selectedLine }).then((res) => {
                        this.getEvents();
                        this.planning = false;
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    this.$axios.post(route('api.vector.planning.add', [this.account, this.selectTask, newDate + " " + newTime]), { 'lineData': this.selectedLine }).then((res) => {
                        this.getEvents();
                        this.planning = false;
                    }).catch((err) => {
                        console.log(err);
                    });
                }
                this.resetFields();
            } else {
                this.error = true;
            }
        },
        editEvent({ nativeEvent, event }) {
            this.editing = true;
            this.openedPlanningId = event.moreInformation.split(':')[0];
            this.selectDay = this.weekdays[new Date(event.start).getDay()];

            var date = new Date(event.start).toLocaleString();
            var splitted = date.split(' ')[1].split(':').splice(0, 2);
            let time = splitted.join(':');
            this.time = time;

            this.selectTask = this.tasks.find(({ taskId }) => taskId === Number(event.moreInformation.split(':')[1])).taskId;
            this.planning = true;
            nativeEvent.stopPropagation()
        },
        deleteEvent() {
            this.$axios.post(route('api.vector.planning.delete', this.openedPlanningId)).then((res) => {
                this.getEvents();
                this.planning = false;
            }).catch((err) => {
                console.log(err);
            });
            this.resetFields();
        },
        intervalFormat(locale, getOptions) {
            return locale.time;
        },
        onSelectRoute() {
            this.selectingLine = true;
            const selectedTask = this.tasks.find(({ taskId }) => taskId === this.selectTask);
            this.$emit("openTask", selectedTask);
            this.dialog = false;
            this.planning = false;
        },
        onLineSelected(lineData) {
            this.selectingLine = false;
            this.selectedLine = lineData.lineData.layer;
            this.$emit("closeTask");
            this.dialog = true;
            this.planning = true;

            console.log(this.selectedLine);
        },
        resetFields() {
            this.selectedLine = null;
            this.selectTask = { taskId: 0, name: "taak" };
        }
    }
};
</script>
<style>
.v-event-draggable {
    padding-left: 6px;
}

.v-event-timed {
    user-select: none;
    -webkit-user-select: none;
}

.v-calendar-daily_head-day-label {
    display: none;
}
</style>